module.exports = __webpack_public_path__ + "img/33_71.b95b4614.png";